/* Cart page quantity controls for the Formula Calculator.

   1. RTF bottles ship shrink-wrapped (6 per pack, 24 for the 90ml lines) and
      the smallest sellable quantity is the smallest bundle (18, 12 or 24).
      The single-bottle variants therefore step by the pack size and cannot
      go below that minimum. No line can be stepped down to 0 either (that
      would delete the row on the spot) - the trash icon removes a line.
   2. This theme's cart page runs in non-ajax mode: quantities were only sent
      on "Checkout", so the totals never moved while clicking. Every quantity
      change is now sent to /cart/update.js, which also returns the rendered
      cart section in the same response (one round trip), so the totals
      update. Clicks are collected for 150 ms and sent together in ONE
      request; clicks made while a request is running go out together in the
      next one, and only the last response is rendered, so quick successive
      clicks (even on different rows) don't make the page flash or show
      stale numbers.

   Powder single-can ("1 pack") lines have a minimum of 2 cans.

   RULES is generated by build-theme-assets.py from the calculator data:
   { "<variantId>": { step, min } } for every RTF single-bottle and powder
   single-can variant. Rows not in the map fall back to reading "1 bottle" /
   "90ml" / "1 pack" from the row text; every other line keeps a step of 1
   and a minimum of 1. */
(function () {
  var RULES = {"45133987676324": {"step": 6, "min": 18}, "45133988429988": {"step": 6, "min": 18}, "45133990756516": {"step": 6, "min": 18}, "45133987414180": {"step": 6, "min": 18}, "51719632978283": {"step": 24, "min": 24}, "45134003142820": {"step": 24, "min": 24}, "45133991215268": {"step": 6, "min": 18}, "45134006517924": {"step": 6, "min": 18}, "45134007173284": {"step": 6, "min": 18}, "45211434090660": {"step": 6, "min": 12}, "52969478750571": {"step": 6, "min": 18}, "45211439759524": {"step": 6, "min": 18}, "46150223134884": {"step": 6, "min": 18}, "53794783232363": {"step": 6, "min": 18}, "53795068510571": {"step": 6, "min": 18}, "53795555508587": {"step": 6, "min": 18}, "45125550538916": {"step": 1, "min": 2}, "45132917801124": {"step": 1, "min": 2}, "45132920094884": {"step": 1, "min": 2}, "45259738120356": {"step": 1, "min": 2}, "45134129561764": {"step": 1, "min": 2}, "45134148665508": {"step": 1, "min": 2}, "45132886376612": {"step": 1, "min": 2}, "45132901187748": {"step": 1, "min": 2}, "45187066134692": {"step": 1, "min": 2}, "45187067543716": {"step": 1, "min": 2}, "45134026506404": {"step": 1, "min": 2}, "45134027456676": {"step": 1, "min": 2}, "45134028046500": {"step": 1, "min": 2}, "45187072884900": {"step": 1, "min": 2}, "45187080159396": {"step": 1, "min": 2}, "53363954745707": {"step": 1, "min": 2}, "53363988922731": {"step": 1, "min": 2}, "53364564132203": {"step": 1, "min": 2}, "53364678099307": {"step": 1, "min": 2}, "53363727073643": {"step": 1, "min": 2}, "45134025883812": {"step": 1, "min": 2}, "51747550069099": {"step": 1, "min": 2}, "51746683158891": {"step": 1, "min": 2}, "45132935921828": {"step": 1, "min": 2}, "45132942606500": {"step": 1, "min": 2}, "45132943556772": {"step": 1, "min": 2}, "51997122625899": {"step": 1, "min": 2}, "51997008593259": {"step": 1, "min": 2}, "45134274068644": {"step": 1, "min": 2}, "45134301233316": {"step": 1, "min": 2}, "45134333706404": {"step": 1, "min": 2}, "45134589001892": {"step": 1, "min": 2}, "45134629798052": {"step": 1, "min": 2}, "45134634287268": {"step": 1, "min": 2}, "45134641201316": {"step": 1, "min": 2}, "45134593130660": {"step": 1, "min": 2}, "45134436565156": {"step": 1, "min": 2}, "45134464581796": {"step": 1, "min": 2}, "45134471463076": {"step": 1, "min": 2}, "45134573011108": {"step": 1, "min": 2}, "45134578581668": {"step": 1, "min": 2}, "53358724383083": {"step": 1, "min": 2}, "53361762074987": {"step": 1, "min": 2}, "53361768300907": {"step": 1, "min": 2}, "53361799135595": {"step": 1, "min": 2}, "51698731778411": {"step": 1, "min": 2}, "51698737643883": {"step": 1, "min": 2}, "51698738790763": {"step": 1, "min": 2}, "53363740836203": {"step": 1, "min": 2}, "51685348409707": {"step": 1, "min": 2}, "45134749302948": {"step": 1, "min": 2}, "45134760050852": {"step": 1, "min": 2}, "45143819583652": {"step": 1, "min": 2}, "51685289034091": {"step": 1, "min": 2}, "51685329371499": {"step": 1, "min": 2}, "51685343297899": {"step": 1, "min": 2}, "51698652709227": {"step": 1, "min": 2}, "51698703368555": {"step": 1, "min": 2}, "51698722996587": {"step": 1, "min": 2}, "53358711472491": {"step": 1, "min": 2}, "53361004216683": {"step": 1, "min": 2}, "53361274716523": {"step": 1, "min": 2}, "45135840608420": {"step": 1, "min": 2}, "45135844606116": {"step": 1, "min": 2}, "45135849914532": {"step": 1, "min": 2}};
  var pending = {};
  var busy = false;

  function rowOf(el) {
    return el.closest(".cart__item");
  }

  function ruleFor(input) {
    var step = 1;
    var min = 1;
    var key = (input.dataset.variantId || "").split(":")[0];
    var rule = RULES[key];
    if (rule) {
      step = rule.step;
      min = Math.max(rule.min, 1);
    } else {
      var row = rowOf(input);
      var variant = row && row.querySelector(".cart__info--variant");
      if (variant && /1 bottle/i.test(variant.textContent)) {
        var link = row.querySelector(".cart__info--text a");
        step = link && /90ml/i.test(link.textContent) ? 24 : 6;
      } else if (variant && /1 pack/i.test(variant.textContent)) {
        min = 2;
      }
    }
    return { step: step, min: min };
  }

  // The calculator's single-bottle / single-can lines are the only ones with
  // an ordering rule the customer can't see on a product page, so these rows
  // get a one-line note under the variant name. Inline styles: the calculator
  // stylesheet is only loaded on product pages.
  function noteText(rule) {
    if (rule.step > 1) return "Sold in multiples of " + rule.step + " · minimum " + rule.min;
    return "Minimum " + rule.min + " cans";
  }

  function addNotes() {
    document.querySelectorAll(".cart__item").forEach(function (row) {
      if (row.querySelector(".fc-cart-note")) return;
      var input = row.querySelector("[data-qty-input]");
      var variant = row.querySelector(".cart__info--variant");
      var rule = input && RULES[(input.dataset.variantId || "").split(":")[0]];
      if (!rule || !variant) return;
      var note = document.createElement("div");
      note.className = "fc-cart-note";
      note.style.cssText = "font-size:12px;line-height:1.4;color:#6b6b66;margin-top:2px;";
      note.textContent = noteText(rule);
      variant.insertAdjacentElement("afterend", note);
    });
  }

  function setRowValue(row, value) {
    row.querySelectorAll("[data-qty-input]").forEach(function (i) {
      i.value = value;
    });
  }

  function dimTotals(on) {
    document.querySelectorAll(".cart__ptotal, .cart__total").forEach(function (el) {
      el.style.opacity = on ? "0.45" : "";
    });
  }

  function render(html) {
    var holder = document.createElement("div");
    holder.innerHTML = html;
    var script = holder.querySelector("#cartJavascript");
    if (script) script.remove();
    var fresh = holder.querySelector(".shopify-section.section--cart-page");
    var current = document.querySelector(".shopify-section.section--cart-page");
    if (!fresh || !current) return;
    current.innerHTML = fresh.innerHTML;
    addNotes();
    if (window.BoosterTheme && BoosterTheme.events) {
      BoosterTheme.events.trigger("booster:content:update", { trigger: "cart-page" });
    }
  }

  // After any /cart call the theme fires "booster:cart:update", which makes
  // cartPage re-fetch and re-render the whole cart section a second time
  // (~0.6s later) and wipes in-flight edits. The response we already render
  // is complete, so that refresh is swallowed while our own request runs
  // and shortly after. Every cart change on this page goes through this
  // script (quantity buttons, typing, trash icon), so nothing else relies on it.
  var suppressUntil = 0;
  document.addEventListener(
    "booster:cart:update",
    function (e) {
      if (Date.now() < suppressUntil) e.stopImmediatePropagation();
    },
    true
  );

  function flush() {
    var keys = Object.keys(pending);
    if (!keys.length) {
      busy = false;
      return;
    }
    busy = true;
    suppressUntil = Date.now() + 10000;
    var updates = pending;
    pending = {};

    fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ updates: updates, sections: "cart-page", sections_url: "/cart" }),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (res) {
        suppressUntil = Date.now() + 2000;
        var failed = res && res.status && res.status !== "success";
        if (failed && window.BoosterTheme) BoosterTheme.cart.error(res);
        if (!Object.keys(pending).length) {
          if (!failed && res && res.sections && res.sections["cart-page"]) {
            render(res.sections["cart-page"]);
          } else if (typeof cartPage !== "undefined" && cartPage.updateCart) {
            cartPage.updateCart();
          }
          dimTotals(false);
        }
        flush();
      })
      .catch(function () {
        pending = {};
        busy = false;
        dimTotals(false);
      });
  }

  // A very short collection window, so a quick burst of clicks (even on
  // different rows) leaves as one request instead of two back to back.
  var sendTimer = null;
  function schedule() {
    dimTotals(true);
    if (busy) return;
    clearTimeout(sendTimer);
    sendTimer = setTimeout(flush, 150);
  }

  function commit(input, quantity) {
    pending[input.dataset.variantId] = quantity;
    schedule();
  }

  function nextQuantity(value, increase, rule) {
    var step = rule.step;
    if (increase) return Math.max((Math.floor(value / step) + 1) * step, rule.min);
    var next = (Math.ceil(value / step) - 1) * step;
    return next < rule.min ? null : next;
  }

  document.addEventListener(
    "click",
    function (e) {
      var button = e.target.closest && e.target.closest(".cart__item .quantity--input__button");
      if (!button) return;
      var input = button.closest(".quantity--input").querySelector("[data-qty-input]");
      if (!input) return;

      e.preventDefault();
      e.stopPropagation();

      var rule = ruleFor(input);
      var value = parseInt(input.value, 10) || 0;
      var increase = button.textContent.trim() === "+";
      var next = nextQuantity(value, increase, rule);
      if (next === null || next === value) return;

      var max = parseInt(input.max, 10);
      if (increase && !isNaN(max) && next > max) {
        if (window.BoosterTheme) BoosterTheme.cart.error({ description: "Seems like there are no more items in stock." });
        return;
      }
      setRowValue(rowOf(input), next);
      commit(input, next);
    },
    true
  );

  document.addEventListener(
    "click",
    function (e) {
      var trigger = e.target.closest && e.target.closest(".cart__item [onclick*='cartPage.removeItem']");
      if (!trigger) return;
      var match = /removeItem\(this,\s*'([^']+)'\)/.exec(trigger.getAttribute("onclick"));
      if (!match) return;
      e.preventDefault();
      e.stopPropagation();
      var row = trigger.closest(".cart__item");
      if (row) row.style.opacity = "0.4";
      pending[match[1]] = 0;
      schedule();
    },
    true
  );

  document.addEventListener(
    "change",
    function (e) {
      var input = e.target;
      if (!input.matches || !input.matches(".cart__item [data-qty-input]")) return;
      var rule = ruleFor(input);
      var value = parseInt(input.value, 10) || 0;
      var next = Math.max(Math.ceil(value / rule.step) * rule.step, rule.min);
      setRowValue(rowOf(input), next);
      commit(input, next);
    },
    true
  );

  // First paint, plus any re-render of the cart section by the theme itself.
  function watchNotes() {
    addNotes();
    var section = document.querySelector(".shopify-section.section--cart-page");
    if (section && window.MutationObserver) {
      new MutationObserver(addNotes).observe(section, { childList: true, subtree: true });
    }
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", watchNotes);
  else watchNotes();
})();
